import { usePage } from '@inertiajs/react'
import { ReactNode, useEffect, useRef } from 'react'
import toast from 'react-hot-toast'
import TabStrip from './TabStrip'
import TopBar from './TopBar'

type CurrentUser = {
  id: number
  name: string
  email: string
  role: string
  initials: string | null
  photo_url: string | null
}

type SharedProps = {
  current_user: CurrentUser | null
  flash: { notice: string | null; alert: string | null }
}

type Props = {
  active: 'dashboard' | 'users' | 'question_templates'
  hideTabs?: boolean
  subHeader?: ReactNode
  children: ReactNode
}

export default function AppLayout({ active, hideTabs = false, subHeader, children }: Props) {
  const { props } = usePage<SharedProps & { [key: string]: unknown }>()
  const user = props.current_user
  const flash = props.flash
  const lastFlashRef = useRef<string>('')

  useEffect(() => {
    const key = `${flash?.notice ?? ''}|${flash?.alert ?? ''}`
    if (key === '|' || key === lastFlashRef.current) return
    lastFlashRef.current = key
    if (flash?.notice) toast.success(flash.notice)
    if (flash?.alert) toast.error(flash.alert)
  }, [flash?.notice, flash?.alert])

  if (!user) return null
  const isManager = user.role === 'manager'

  return (
    <div className="min-h-screen bg-ce-off-white font-sans">
      <TopBar currentUser={user} />
      {!hideTabs && <TabStrip active={active} showUsers={isManager} showTemplates={isManager} />}
      {subHeader}
      <div className="mx-auto w-full max-w-[1440px] px-5 py-8 md:px-10 md:py-12">
        {children}
      </div>
    </div>
  )
}
